import {Component, Inject, OnInit} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Ship} from "../../../model";

export interface DialogData {
  ships: Ship[];
}

@Component({
  selector: 'app-ship-selection-dialog',
  templateUrl: './ship-selection-dialog.component.html',
  standalone: false
})
export class ShipSelectionDialogComponent implements OnInit{
  selectedShipId: string | undefined;

  constructor(
    public dialogRef: MatDialogRef<ShipSelectionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  ngOnInit() {
    if (this.data.ships.length === 1) {
      this.selectedShipId = this.data.ships[0].id_ship;
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

}
